import { pdf } from "@react-pdf/renderer";

import type { DocumentProps } from "@react-pdf/renderer";
import type { ReactElement } from "react";

// Shared across every PDF export in the app (rider-payroll slips, expense
// invoices, ...) — single-tenant, one company, no per-doc variation.
export const PDF_COMPANY = {
  name: "PT JAM COFFEE ABADI",
  address:
    "Jl. Jenderal Ahmad Yani No.70, Kel. Sumurpecung, Kec. Serang, Kota Serang, Banten 42117",
};

export const PDF_COLORS = {
  orange: "#E0702E",
  dark: "#1a1a1a",
  gray: "#6b6b6b",
};

/** "Rp. 180.000" / "Rp. -" for zero. */
export function formatRp(amount: number): string {
  if (!amount) return "Rp. -";
  return `Rp. ${Math.round(amount).toLocaleString("id-ID")}`;
}

/** "09/10/2026 22:47" — when the PDF was generated. */
export function formatGeneratedAt(date: Date = new Date()): string {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${day}/${month}/${date.getFullYear()} ${hours}:${minutes}`;
}

/** Inserts a "-20261012-1412" generation timestamp before the file extension. */
function withGeneratedTimestamp(
  filename: string,
  date: Date = new Date(),
): string {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const stamp = `${date.getFullYear()}${month}${day}-${hours}${minutes}`;
  const dot = filename.lastIndexOf(".");
  if (dot === -1) return `${filename}-${stamp}`;
  return `${filename.slice(0, dot)}-${stamp}${filename.slice(dot)}`;
}

/** Renders a react-pdf document to a blob and triggers a browser download. */
export async function downloadPdf(
  element: ReactElement<DocumentProps>,
  filename: string,
): Promise<void> {
  const blob = await pdf(element).toBlob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = withGeneratedTimestamp(filename);
  a.click();
  URL.revokeObjectURL(url);
}
